import $ from "jquery";

const init = () => {
  addStickyHeader();
};

const addStickyHeader = () => {
  document.addEventListener("scroll", function () {
    if ($(document).scrollTop() === 0) {
      $(".elementor-sticky").removeClass("sticky-active");
    } else {
      $(".elementor-sticky").addClass("sticky-active");
    }
  });
};

try {
  init();
} catch (error) {
  console.log(error);
}
